module.exports = __webpack_public_path__ + "media/images/front/icons/products-c6c7346807a746643125cf0e945f1c1c.png";